import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { Subscription } from 'rxjs';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

import { DirectionService } from '../../direction.service';
import { AuthService } from 'src/app/auth/auth.service';
import { DialogService } from 'src/app/dialog/dialog.service';

import { UsersService } from 'src/app/super-management/user/users.service';
import { set } from 'lodash';

import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-delete-user',
  templateUrl: './delete-user.component.html',
  styleUrls: ['./delete-user.component.css'],
  host: {
    class: 'fill-screen-modal-phone'
  }
})
export class DeleteUserComponent implements OnInit, OnDestroy {
  isRTL: boolean = true;
  private directionSubscription: Subscription;
  isDarkMode: boolean = false;
  isLoading: boolean = false;
  isLoadingUpdates = false;

  userId: string;
  userIsAuthenticated = false;
  private authStatusSub: Subscription;

  user: any;
  isSU: boolean = false;
  isDeleted: boolean = false;

  constructor(
    private directionService: DirectionService,
    private authService: AuthService,
    private dialogService: DialogService,
    private usersService: UsersService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _snackBar: MatSnackBar,
    private translate: TranslateService,
  ) {
    this.user = data.user;
    this.isSU = data.isSU;
  }

  async ngOnInit() {
    this.isLoading = true;
    this.directionSubscription = this.directionService.direction$.subscribe(direction => {
      this.isRTL = direction === 'rtl';
    });

    this.directionService.isDarkMode$.subscribe(isDarkMode => {
      this.isDarkMode = isDarkMode;
    });

    this.userId = this.authService.getUserId();
    this.userIsAuthenticated = this.authService.getIsAuth();
    this.authStatusSub = this.authService
      .getAuthStatusListener()
      .subscribe(isAuthenticated => {
        this.userIsAuthenticated = isAuthenticated;
        this.userId = this.authService.getUserId();
      });

    this.isLoading = false;
  }

  closeDeleteUserDialog() {
    this.dialogService.onCloseDeleteUserDialog();
  }

  onDeleteUser(user: any) {
    const msg = this.translate.instant('error-content-USER_DELETION_FAILED');
    this.isLoadingUpdates = true;
    this.usersService.deleteUser(user._id, this.isSU).subscribe(
      (response) => {
        // בדוק אם יש message עם ערך חיובי, או פשוט כל תשובה
        if (response && response.message === "Deletion successful!") {
          this.usersService.emitusersUpdated();
          if (!this.isSU) {
            // מחיקה עצמית מהפרופיל – אותה הודעה כמו בניסיון התחברות לחשבון מחוק
            this.dialogService.onCloseDeleteUserDialog();
            this.authService.logout().then(() => {
              this.dialogService.onOpenErrorDialog({ message: 'USER_ACCOUNT_DELETED' });
            });
          } else {
            this.isDeleted = true;
            setTimeout(() => {
              this.dialogService.onCloseDeleteUserDialog();
            }, 1300);
          }
        } else {
          this.isLoadingUpdates = false;
          this._snackBar.open(msg, "X", { duration: 3000 });
        }
      },
      (error) => {
        this.isLoadingUpdates = false;
        this._snackBar.open(msg, "X", { duration: 3000 });
      }
    );
  }

  ngOnDestroy() {
    if (this.directionSubscription) {
      this.directionSubscription.unsubscribe();
    }
    if (this.authStatusSub) {
      this.authStatusSub.unsubscribe();
    }
  }

  // ===============
}
